<template>
  <label class="radio-label" :for="id">
    <input type="radio" :id="id" :checked="shouldBeChecked" :value="value" v-model="modelValue" @change="updateInput" />
    {{ label }}
    <span></span>
  </label>
</template>

<script>
export default {
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    value: {
      type: [String, Boolean],
    },
    modelValue: {
      default: "",
    },
    label: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: false,
    },
  },
  computed: {
    shouldBeChecked() {
      return this.modelValue == this.value;
    },
  },
  methods: {
    updateInput() {
      this.$emit("change", this.value);
    },
  },
};
</script>

<style>
</style>
